import { useContext } from 'react';
import NavigationContext from '../navigation/NavigationContext.js';

var useNavigation = function useNavigation() {
  var _ref = useContext(NavigationContext) || {},
      _ref$isSignedIn = _ref.isSignedIn,
      isSignedIn = _ref$isSignedIn === void 0 ? false : _ref$isSignedIn,
      mainNavWrapperRef = _ref.mainNavWrapperRef,
      subNavWrapperRef = _ref.subNavWrapperRef;

  return {
    isSignedIn: isSignedIn,
    mainNavWrapperRef: mainNavWrapperRef,
    subNavWrapperRef: subNavWrapperRef
  };
};

var useNavigation$1 = useNavigation;

export { useNavigation$1 as default };
